import type { ReservationValidation } from '@/data/models/reservation.model';

/** API field names for passenger home / mobile phones (case-insensitive). */
const MEMBER_PHONE_VALIDATION_FIELDS = new Set([
  'memberhomephone',
  'membermobilephone',
]);

export function filterReservationErrorsExcludingMemberPhones(
  errors: ReservationValidation[],
): ReservationValidation[] {
  return errors.filter(
    (e) =>
      !MEMBER_PHONE_VALIDATION_FIELDS.has(e.fieldName.trim().toLowerCase()),
  );
}
